import { ChangeDetectorRef, Component, signal } from '@angular/core';
import { CalendarOptions, DateSelectArg, EventClickArg, EventApi } from '@fullcalendar/core';
import interactionPlugin from '@fullcalendar/interaction';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import { createEventId, INITIAL_EVENTS } from './event-utils';
import * as moment from 'moment';
import { WorklogService } from 'src/app/module/budgets/services/worklog.service';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AddWorklogComponent } from 'src/app/module/budgets/components/add-budget/add-worklog.component';
import { MessageService } from 'primeng/api';
import { EmsServicesService } from 'src/app/module/ems-master/services/pms-services.service';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.css']
})
export class CalendarComponent {
  theme = 'dark'
  calendarVisible = signal(true);
  calendarOptions = signal<CalendarOptions>({
    plugins: [
      interactionPlugin,
      dayGridPlugin,
      listPlugin,
      timeGridPlugin
      // timeGridPlugin,
      // listPlugin,
    ],
    headerToolbar: {
      left: 'prev,next today',
      center: 'title',
      right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek'
    },
    initialView: 'dayGridMonth',
    initialEvents: INITIAL_EVENTS,
    weekends: true,
    editable: false,
    droppable: false,
    selectable: true,
    selectMirror: true,
    dayMaxEvents: true,
    aspectRatio: navigator.userAgent.includes('Mobile') ? 1 : 3,
    longPressDelay: 0,
    expandRows: true,
    nowIndicator: true,
    
    dayCellClassNames: 'fillBgColor',

    businessHours: {
      // days of week. an array of zero-based day of week integers (0=Sunday)
      daysOfWeek: [ 1, 2, 3, 4, 5 ], // Monday - Thursday
    
      startTime: '09:00',
      endTime: '18:00',
    },
    
    select: this.handleDateSelect.bind(this),
    eventClick: this.handleEventClick.bind(this),
    eventsSet: this.handleEvents.bind(this),
    datesSet: this.handleDatesSet.bind(this) ,
    eventDidMount: this.addTooltip.bind(this)
    /* you can update a remote database when these fire:
    eventAdd:
    eventChange:
    eventRemove:
    */
  });
  currentEvents = signal<EventApi[]>([]);

  addCalenderDetailPopup = false;
  eventTitle:any;
  selectInfo:any;
  allDayEvent:any;
  startTime:any;
  endTime:any;
  selectedStartTime :any;
  selectedEndTime :any;

  deleteCalenderDetailPopup = false;
  clickInfo:any;
  calendarData:any;
  employeeId:any;
  filters:any;
  ref: DynamicDialogRef | undefined;
  sendStartDate:any;
  sendEndDate:any;
  searchDropDownToggle = false;
  employeeLists:any[]=[]
  
  searchForm: FormGroup;
  employeeDataView = false
  role:any;
  colorsContainerData = [
    {title: 'Upto 25%', colorCode: '#FFBF00'},
    {title: 'Upto 50%', colorCode: '#7c9bdf'},
    {title: 'Upto 75%', colorCode: '#95b489'},
    {title: 'Upto 100%', colorCode: '#315822'},
    {title: 'Absent', colorCode: '#f86c6c'},
    {title: 'Leave', colorCode: '#777272'},
    {title: 'Holiday', colorCode: '#b7e9f1'},
  ]

  constructor(
    private changeDetector: ChangeDetectorRef,
    public WorklogService: WorklogService,
    public dialogService: DialogService,
    public messageService: MessageService,
    private emsServices: EmsServicesService
  ) {
    this.searchForm = new FormGroup({
          EMPLOYEE_ID_IN: new FormControl(null)
        });
    const userDetails = JSON.parse(localStorage.getItem('user_details')!);
    this.role = JSON.parse(localStorage.getItem('role')!)
    this.employeeId = userDetails.id
    this.sendStartDate
    console.log(navigator.userAgent.includes('Mobile'),'<------------navigator.userAgent')
  }

  ngOnInit(): void {
    this.getEmployeeList()
  }

  getEmployeeList(){
    this.emsServices
    .getEmployees([], 0, 50000,'Id','DESC')
    .subscribe((data: any) => {
      this.employeeLists = data?.responseObject?.content;
    });
  }

  onReset(){
    this.employeeDataView = false
    const userDetails = JSON.parse(localStorage.getItem('user_details')!);
    this.employeeId = userDetails.id
    this.getList()
    this.searchDropDownToggle = false
  }
  
  onSubmit(){
    this.employeeDataView = true
    this.employeeId = this.searchForm.controls['EMPLOYEE_ID_IN'].value
    this.getList()
    this.searchDropDownToggle = false
  }

  handleCalendarToggle() {
    this.calendarVisible.update((bool) => !bool);
  }

  handleWeekendsToggle() {
    this.calendarOptions.mutate((options) => {
      options.weekends = !options.weekends;
    });
  }

  handleDateSelect(selectInfo: DateSelectArg) {
    if(this.employeeDataView){
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'The action cannot be performed because a filter is applied.',
      });
    }
    else{
      const isFutureDate = this.isFutureDate(selectInfo.startStr);
      if(!isFutureDate){
        this.eventTitle = null
        this.selectInfo = null
        this.allDayEvent = null
        this.startTime = null
        this.endTime = null
        this.selectedStartTime = null;
        this.selectedEndTime = null;
        this.selectInfo = selectInfo
        this.AddWorklog('Add',this.selectInfo)
      }
      else{
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Cannot add worklog for future dates',
        });
      }
    }
  }

  handleEventClick(clickInfo: EventClickArg) {
    if(this.employeeDataView){
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'The action cannot be performed because a filter is applied.',
      });
    }
    else{
      this.clickInfo = clickInfo
      this.AddWorklog('Edit',this.clickInfo)
    }
  }

  isFutureDate(dateString: string): boolean {
    const givenDate = new Date(dateString + 'T00:00:00');
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    givenDate.setHours(0, 0, 0, 0);
    return givenDate > today;
  }

  handleEvents(events: EventApi[]) {
    this.currentEvents.set(events);
    this.changeDetector.detectChanges();
  }

  addTooltip(info: any) {
      const eventElement = info.el;
      const startTime = moment(info.event?.extendedProps?.startDate).format('hh:mm a')
      const endTIme = moment(info.event?.extendedProps?.endDate).format('hh:mm a')
      eventElement.setAttribute('title', info.event.title + ' ' + '(' + startTime + '-' + endTIme +  ')' ); 
      eventElement.setAttribute('pTooltip', info.event.title);
      eventElement.setAttribute('tooltipPosition', 'top');
      eventElement.classList.add('p-element'); 
      
      // Manually trigger PrimeNG tooltip
      setTimeout(() => {
      if ((window as any).PrimeNG) {
        (window as any).PrimeNG.tooltip.init();
      }
    }, 100);
  }

  handleDatesSet(dateInfo: any) {
    let start = moment(dateInfo.startStr).format('DD-MM-YYYY HH:mm:ss Z');
    this.sendStartDate = start.replace(/(\+\d{2}):(\d{2})/, "$1$2"); 
    
    let end = moment(dateInfo.endStr).format('DD-MM-YYYY HH:mm:ss Z');
    this.sendEndDate = end.replace(/(\+\d{2}):(\d{2})/, "$1$2"); 
    
    console.log(this.sendStartDate,this.sendEndDate,'start-end')
    this.getList();
  }

  selectAllDayEvent(event:any){
    console.log(event,'selectAllDayEvent')
  }

  selectTime(event:any, type:any){
    console.log(event,type)
    if(type === 'startTime'){
      const startTime = moment(event).format('HH:mm:ss')
      this.startTime = this.selectInfo.startStr + ' ' + startTime
    }
    if(type === 'endTime'){
      const endTime = moment(event).format('HH:mm:ss')
      this.endTime = this.selectInfo.startStr + ' ' + endTime
    }
  }

  submit(){
    const calendarApi = this.selectInfo.view.calendar;
    calendarApi.unselect();
    if (this.eventTitle) {
      calendarApi.addEvent({
        id: createEventId(),
        title: this.allDayEvent ? this.eventTitle : ' - ' + this.eventTitle,
        start: this.allDayEvent ? this.selectInfo.startStr : this.startTime,
        end: this.allDayEvent ? this.selectInfo.endStr : this.endTime,
        className: 'hoursComplete',
        allDay: this.allDayEvent
      });
    }
    this.addCalenderDetailPopup = false
  }

  deleteCalendar(){
    this.clickInfo.event.remove();
    this.deleteCalenderDetailPopup = false
  }

  formatDate(dateStr: string): string {
    return moment(dateStr, "DD-MM-YYYY HH:mm:ss Z").format("YYYY-MM-DDTHH:mm:ss");
  }

  generateRandomNumber() {
    let number = '';
    for (let i = 0; i < 5; i++) {
        number += Math.floor(Math.random() * 9) + 1; 
    }
    return number;
}

  getList() {
    const filter = {
      employeeId: this.employeeId,
      start: this.sendStartDate,
      end: this.sendEndDate
    };
  
    this.WorklogService.getWorkSummary(filter).subscribe((data: any) => {
      if (data?.responseObject) {
        this.calendarData = data.responseObject.map((event: any) => ({
          id: event.id ? event.id.toString() : this.generateRandomNumber(),
          title: event.title || 'No Title',
          start: event.start ? this.formatDate(event.start) : null,
          end: event.end ? this.formatDate(event.end) : null,
          startDate: event.start ? this.formatDate(event.start) : null,
          endDate: event.end ? this.formatDate(event.end) : null,
          className: event.className || '',
          taskDescription: event.taskDescription || '',
          projectName: event.projectName || '',
          projectId: event.projectId || '',
          logDate: event?.logDate ? event?.logDate : null ,
          minutes: event?.minutes ? event?.minutes : 0 ,
          status: event.statusDescription || ''
        }));
  
        // Update calendar options dynamically
        this.calendarOptions.mutate((options) => {
          options.events = this.calendarData;
        });
  
        this.changeDetector.detectChanges();
      }
    }, err => {
      this.calendarData = [];
      this.calendarOptions.mutate((options) => {
        options.events = this.calendarData;
      });
      this.changeDetector.detectChanges();
    });
  }

  AddWorklog(type:any,data:any) {
    const editData = []
    if(type === 'Edit'){
      editData.push(data.event._def)
    }
      this.ref = this.dialogService.open(AddWorklogComponent, {
        header: `${type} Worklog`,
        data: type == 'Add' ? 
        {
          selectedDate: data?.start,
          // startDateTime: data?.start,
          // endDateTime: data?.end,
          addCalender: true
        } 
        : {
          data: editData,
          editCalender: true
          // editData : this.selectedData,
          // edit: this.editContation
        },
        width: '70vw',
        contentStyle: { overflow: 'auto', position: "top" },
        draggable: true,
        styleClass: 'no-close-icon-dialog',
      });
      this.ref.onClose.subscribe((data: any) => {
        console.log("resss", data)
        if (data) {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: data?.responseMessage,
          });
        }
        this.getList()
      });
    }
  
}